import { colors } from 'fitify-ui'
import { ArrowRightIcon } from 'fitify-ui/src/Icon/outline'
import Button from 'fitify-ui-landing/src/components/Button/Button'
import { Typography } from 'fitify-ui-landing/src/components/Typography/Typography'
import { createRedirectLinkWithLocale } from 'fitify-ui-landing/src/utils/link'
import { useTranslation } from 'next-i18next'

import {
  StyledContent,
  StyledContainer,
} from '@/components/exercises/Cta/Cta.Styled'

export const Cta = () => {
  const { i18n, t } = useTranslation()

  return (
    <StyledContainer>
      <StyledContent>
        <Typography
          $color={colors.White}
          $variant="Headline/H 28 Bold"
          $variantPhone="Headline/H 24 Bold"
        >
          {t('landing_exercises_cta_title')}
        </Typography>

        <Typography
          $color={colors.Gray400}
          $variant="Text/Body 16"
          $variantPhone="Text/Body 14"
        >
          {t('landing_exercises_cta_description')}
        </Typography>
      </StyledContent>
      <Button
        icon={<ArrowRightIcon />}
        variant="primary-blue"
        href={createRedirectLinkWithLocale(
          process.env.NEXT_PUBLIC_ONBOARDING_URL,
          i18n.language
        )}
        target="_blank"
      >
        {t('landing_exercises_cta_button')}
      </Button>
    </StyledContainer>
  )
}
